export enum TemplateLoaderKey {
  LIST_TEMPLATES = 'list-templates',
  PREVIEW_TEMPLATE = 'preview-template',
}
